export default (permalink, title, practice_area, location) => `
<a class="single-item" href="${permalink}">
    <div class="single-item-inner">
        <div class="position">
            <h4>${title}</h4>
        </div>
        <div class="practic-area">
            <span>${practice_area}</span>
        </div>
        <div class="office">
            <div class="btn-stroke mini-padding inner">
                <span>${location}</span>
            </div>
        </div>
    </div>
    <span class="arrow-more">
        <div class="arrow-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.326 10.191">
                <g id="Group_264" data-name="Group 264"
                   transform="translate(-249.262 -2948.368)">
                    <path id="Path_101" data-name="Path 101" d="M251.061,2952.8h19.619"
                          transform="translate(-1.799 0.697)" fill="none"
                          stroke="#e0c084"
                          stroke-width="1"/>
                    <path id="Path_102" data-name="Path 102"
                          d="M268.868,2943.84l4.742,4.742-4.742,4.742"
                          transform="translate(-4.729 4.882)" fill="none"
                          stroke="#e0c084"
                          stroke-width="1"/>
                </g>
            </svg>
        </div>
    </span>
</a>

`